<template>
  <section class="front_cover_1">
    <div class="content_box">
      <div class="cover1_box">
        <m-video
          key="1"
          v-if="video1Visible"
          class="video_1"
          poster="@/auto/assets/video/1/index1.png"
          src="@/auto/assets/video/1/index1.mp4"
          width="100%"
          @ended="videoEnded($event)"
          muted
          autoplay
        ></m-video>
        <m-video
          key="2"
          class="video_1"
          poster="@/auto/assets/video/1/index2.png"
          src="@/auto/assets/video/1/index2.mp4"
          width="100%"
          muted
          autoplay
          loop
          ref="video"
        ></m-video>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: 'FrontCover',

  data() {
    return {
      preload_: true,
      video1Visible: true,
    }
  },

  methods: {
    videoEnded() {
      this.video1Visible = false

      const video = this.$refs.video
      video.play()
    },
  },
}
</script>

<style lang="less" scoped>
.front_cover_1 {
  height: 100vh;
  width: 100%;
  position: relative;
  background-color: #17181c;

  .content_box {
    width: 100%;
    height: 100vh;
    // max-height: 1080px;
    position: absolute;
    top: 0px;
    left: 50%;
    transform: translateX(-50%);
  }

  .cover1_box {
    position: relative;
    z-index: 1;
    width: 100%;
    height: 100%;
    background-color: #000;
    overflow: hidden;
  }

  .video_1 {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);

    &:first-child {
      z-index: 1;
    }
  }
}
</style>
